import { PutComentarioGerenteArea } from '@app/api/sas/ordemCompra';
import { hasPermission } from '@app/helpers/permissions';
import { FormInput, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import React from 'react';

interface Props {
  ordemCompraId: string;
  comentarioGerenteArea: string;
  onUpdateDadosGerais: () => void;
  statusAguardandoAvaliacao: boolean;
}

const InputComentarioGerenteArea: React.FC<Props> = ({
  ordemCompraId,
  comentarioGerenteArea,
  onUpdateDadosGerais,
  statusAguardandoAvaliacao,
}) => {
  const enviarComentarioGerenteArea = (e: any) => {
    PutComentarioGerenteArea({
      ordemCompraId: ordemCompraId,
      comentarioGerenteArea: e.comentarioGerenteArea,
    }).then(() => {
      onUpdateDadosGerais();
    });
  };

  return (
    <MasterDetailForm initialValues={{ comentarioGerenteArea }} onSubmit={enviarComentarioGerenteArea}>
      <Widget
        actions={[
          hasPermission(['SAS_ALTERAR_GERENTE_AREA']) && statusAguardandoAvaliacao && (
            <FormSubmitButton noIcon={true} type="primary">
              ENVIAR COMENTÁRIO
            </FormSubmitButton>
          ),
        ]}>
        <FormInput
          label="Comentário Gerente Geral"
          name="comentarioGerenteArea"
          disabled={!hasPermission(['SAS_ALTERAR_GERENTE_AREA']) || !statusAguardandoAvaliacao}
        />
      </Widget>
    </MasterDetailForm>
  );
};

export default InputComentarioGerenteArea;
